<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <!--
        <v-card-title class="subreading pb-0">Aceso de Usuário</v-card-title>
        -->
        <v-card-text class="pt-2">
            <v-form v-if="formOption==='login'" ref="form" v-model="valid" lazy-validation>
              <div v-if="!formEsqueceuSenha.open" class="text-xs-right pt-0 mt-0">
                <div class="title pt-2 text-xs-center">Login</div>
                <v-text-field v-model="email" :rules="emailRules" label="E-mail" required></v-text-field>
                <v-text-field v-model="senha" :rules="senhaRules" label="Senha" type="password" required></v-text-field>
                <v-btn small flat class="pt-0 mt-0" color="grey" @click="formEsqueceuSenha.open=!formEsqueceuSenha.open">Esqueceu a senha?</v-btn>
                <v-btn :disabled="!valid" color="primary" @click="logarUsuario" block>Login</v-btn>
              </div>
              <div v-else>
                <template v-if="formEsqueceuSenha.recuperando">
                  <div class="title pt-2 text-xs-center">Redefinir senha</div>
                  <div>Enviamos um código para seu e-mail. Informe abaixo e em seguida informe a nova senha:</div>
                  <v-text-field v-model="formEsqueceuSenha.codigo" label="Informe o código" type="password" required></v-text-field>
                  <v-text-field v-model="formEsqueceuSenha.novasenha" :rules="senhaRules" type="password" label="Informe a nova senha" required></v-text-field>
                  <v-btn block small class="pt-0 mt-0" color="primary" @click="efetivarRedefinicaoDeSenha()" :disabled="!valid">Redefinir Senha</v-btn>
                  <v-btn block small class="pt-0 mt-0" color="error" @click="formEsqueceuSenha.open=!formEsqueceuSenha.open,formEsqueceuSenha.recuperando=false">Cancelar</v-btn>
                </template>
                <template v-else>
                  <div class="title pt-2 text-xs-center">Redefinir Senha</div>
                  <v-text-field v-model="formEsqueceuSenha.email" :rules="emailRules" label="Informe seu E-mail" required></v-text-field>
                  
                  <v-btn small block outline class="pt-0 mt-0" color="primary" @click="redefinirSenha" :disabled="!valid">Receber Código</v-btn>
                  <v-btn small block outline class="pt-0 mt-0" color="primary" @click="redefinirSenhaSemGerarCodigo" :disabled="!valid">Informar Código</v-btn>
                  <v-btn small block outline class="pt-0 mt-0" color="error" @click="formEsqueceuSenha.open=!formEsqueceuSenha.open">Cancelar</v-btn>
                  
                  <!--
                  <v-layout>
                    <v-flex xs6>
                      <v-btn small class="pt-0 mt-0" color="error" @click="formEsqueceuSenha.open=!formEsqueceuSenha.open">Cancelar</v-btn>
                    </v-flex>
                    <v-flex xs6>
                      <v-btn small class="pt-0 mt-0" color="primary" @click="redefinirSenha" :disabled="!valid">Redefinir</v-btn>
                    </v-flex>
                  </v-layout>
                  -->
                </template>
              </div>
            </v-form>
            <v-form v-else-if="formOption==='cadastro'" ref="form" v-model="valid" lazy-validation>
              <div class="title pt-2 text-xs-center">Cadastro</div>
              <v-text-field v-model="email" :rules="emailRules" label="E-mail" required></v-text-field>
              <!-- <v-text-field v-model="confirmacao.email" :rules="emailRules" label="Confirme seu E-mail" required></v-text-field> -->
              <v-text-field v-model="senha" :rules="senhaRules" label="Senha" type="password" required></v-text-field>
              <v-select label="Tipo do Cadastro" v-model="mais.documento.tipo" :items="documentoItems"></v-select>
              <v-text-field v-if="mais.documento.tipo=='CPF'" v-model="nome" :counter="50" :rules="nameRules" label="Nome Completo" required></v-text-field>
              <v-text-field v-else-if="mais.documento.tipo=='CNPJ'" v-model="nome" :counter="50" :rules="nameRules" label="Razão Social" required></v-text-field>
              <v-text-field v-if="mais.documento.tipo!=''" v-model="mais.documento.numero" :label="mais.documento.tipo" required></v-text-field>
              <v-text-field v-model="whatsapp" :rules="whatsappRules" label="Whatsapp(DDD+Número)" required></v-text-field>
              <v-text-field v-model="confirmacao.whatsapp" label="Confirme seu Whatsapp(DDD+Número)" required></v-text-field>
              <v-text-field v-if="mais.documento.tipo=='CPF'" v-model="mais.nascimento" label="Data de Nascimento" type="date" required></v-text-field>
              <v-btn :disabled="!valid || mais.documento.tipo==''" color="primary" @click="cadastrarUsuario" block>Cadastrar</v-btn>
            </v-form>
        </v-card-text>
        <v-card-actions fixed v-if="!formEsqueceuSenha.open">
          <v-btn color="error darken-1" flat @click="$emit('fechar-modal')">Cancela</v-btn>
          <v-spacer></v-spacer>
          <v-btn v-if="formOption==='login'" color="primary darken-1" flat @click="formOption='cadastro'">Cadastre-se</v-btn>
          <v-btn v-else-if="formOption==='cadastro'" color="primary darken-1" flat @click="formOption='login'">Login</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import jquery from 'jquery';
export default {
  props: ['dialog','baseUrlApi'],
  data: () => ({
    formEsqueceuSenha: {open: false,recuperando:false,email:"",codigo:"",novasenha:""},
    valid: true,
    nome: "",
    nameRules: [
      v => !!v || "Nome obrigatório",
      v => (v && v.length <= 50) || "Nome com no máximo 50 caracteres"
    ],
    email: "",
    emailRules: [
      v => !!v || "E-mail obrigatório",
      v => /.+@.+/.test(v) || "Insira um E-mail válido"
    ],
    senha: "",
    senhaRules: [
       v => !!v || "Senha obrigatória",
       v => (v && v.length >= 5) || "Senha com no mínimo 5 caracteres"
    ],
    whatsapp: "",
    whatsappRules: [
       v => !!v || "Whatsapp obrigatório",
       v => (v && v.length >= 10 && v.length <= 12) || "Somente números(Ex.: 21987654321)"
    ],
    documentoItems:[{text:'Pessoa Física',value:'CPF'},{text:'Pessoa Jurídica',value:'CNPJ'}],
    formOption: 'login',
    mais: {documento:{tipo:'',numero:''}},
    confirmacao: {
      //erro: null,
      email: '',
      whatsapp: ''
    }
  }),
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    cadastrarUsuario(){
      /*
      if(this.confirmacao.email.replace(" ","") != this.email.replace(" ","")){
        //confirmacao.erro: '';
        alert('O campo Confirme seu E-mail precisa ser igual ao campo E-mail.');
        return;
      }
      */
      if(this.confirmacao.whatsapp !=this.whatsapp){
        //confirmacao.erro: '';
        alert('O campo Confirme seu Whatsapp precisa ser igual ao campo Whatsapp.');
        return;
      }
      if (this.$refs.form.validate()) {
          if(this.mais.documento.numero==""){
            alert("O número do "+this.mais.documento.tipo+" é obrigatório.");
            return;
          }
          if(this.mais.documento.numero.length<11){
            alert("Informe um número de "+this.mais.documento.tipo+" válido.");
            return;
          }
          this.$emit('cadastrar-usuario',{
              nome: this.nome,
              email: this.email.replace(" ",""),
              senha: this.senha,
              whatsapp: this.whatsapp,
              doc: JSON.stringify(this.mais)
          });
      }
    },
    logarUsuario(){
      if (this.$refs.form.validate()) {
          //console.log("Logando");
          this.$emit('logar-usuario',{
              email: this.email.replace(" ",""),
              senha: this.senha
          });
      }
    },
    redefinirSenha(){
      if (this.$refs.form.validate()) {
        console.log(this.baseUrlApi+'user_recuperarSenhaEsquecida/redefinirSenhaEsquecida');
        
        jquery.post(this.baseUrlApi+'user_recuperarSenhaEsquecida/redefinirSenhaEsquecida',{
            email: this.formEsqueceuSenha.email
          }).then(response =>(this.resposta_redefinirSenhaEsquecida(response)));
          /**/
      }else{
        console.log('senha fraca');
      }
    },
    redefinirSenhaSemGerarCodigo(){
      //this.resposta_redefinirSenhaEsquecida();
        this.formEsqueceuSenha.recuperando=true;
        this.formEsqueceuSenha.codigo='';
        this.formEsqueceuSenha.novasenha='';
    },
    resposta_redefinirSenhaEsquecida(dados){
      console.log(dados);
      if(dados.situacao==true){
        this.formEsqueceuSenha.recuperando=true;
        this.formEsqueceuSenha.codigo='';
        this.formEsqueceuSenha.novasenha='';
      }else{
        alert(dados.mensagem);
      }
    },
    efetivarRedefinicaoDeSenha(){
      jquery.post(this.baseUrlApi+'user_recuperarSenhaEsquecida/efetivarAlteracaoDeSenhaEsquecida',{
            email: this.formEsqueceuSenha.email,
            codigo: this.formEsqueceuSenha.codigo,
            senha: this.formEsqueceuSenha.novasenha,
            senhac: this.formEsqueceuSenha.novasenha
          }).then(response =>(this.resposta_efetivarRedefinicaoDeSenha(response)));
    },
    resposta_efetivarRedefinicaoDeSenha(dados){
      console.log(dados.mensagem);
      if(dados.situacao==true){
        this.formEsqueceuSenha.open=false;
        this.formEsqueceuSenha.recuperando=false;
        this.formEsqueceuSenha.codigo='';
        this.formEsqueceuSenha.novasenha='';
        this.email = this.formEsqueceuSenha.email;
        alert(dados.mensagem);
      }else{
        alert(dados.mensagem);
      }
    }
  }
};
</script>